import notificationItemConnector from "../notification-item-connector"

import NotificationEditItem from "./NotificationEditItem"

export default notificationItemConnector(NotificationEditItem)
